import { render } from "./demoHome.vue?vue&type=template&id=f05f6588&scoped=true"
import script from "./demoHome.vue?vue&type=script&lang=js"
export * from "./demoHome.vue?vue&type=script&lang=js"

import "./demoHome.vue?vue&type=style&index=0&id=f05f6588&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05f6588"]])

export default __exports__